import React from 'react';
import { WhatsappShareButton } from 'react-share';
import { useContent } from '../hooks/customHooks';
import Api from '../api/Api';

const WhatsappButton = () => {
    const { content } = useContent();
    const socials = content?.global_settings?.socials;

    const incrementer = () => {
        Api.whatsappShareIncrement().then(res => {});
    };

    return (
        <WhatsappShareButton
            onClick={incrementer}
            url={`${content?.campaignDomain}?utm_source=WhatsAppShare&utm_medium=WhatsApp&utm_campaign=Offer`}
            title={socials?.whats_app}
        >
            <div className="whatsAppBtn">
                <div>
                    <i className="fab fa-whatsapp"></i>
                </div>
                <div>{content?.global_settings?.footer?.whats_app || 'Share on WhatsApp'}</div>
            </div>
        </WhatsappShareButton>
    );
};

export default WhatsappButton;
